// components/TenantActionsMenu.tsx
import React, { useState } from 'react';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useNavigate } from 'react-router-dom';
import { Client } from '../../apis/tenantApi/tenantApi';
import axios from 'axios';
import config from "../../env.json"
import { Alert, Box, Button, Card, CardContent, Checkbox, CircularProgress, Collapse, FormControl, FormControlLabel, Grid, IconButton, InputAdornment, InputLabel, MenuItem, Paper, Radio, RadioGroup, Select, SelectChangeEvent, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip, Typography } from "@mui/material";
import {
  CompareArrows as CompareArrowsIcon,
  ContentCopy as CopyIcon,
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon,
  Check as CheckIcon,
  Visibility as VisibilityIcon,
  VisibilityOff as VisibilityOffIcon,
  Edit as EditIcon
} from '@mui/icons-material';

interface Props {
  tenant: Client;
}

const DatabaseConfigurationActionMenu: React.FC<Props> = ({ tenant }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [migrating, setMigrating] = useState<boolean>(false);
  
  const open = Boolean(anchorEl);
  const navigate = useNavigate();

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleView = () => {
    handleClose();
    navigate(`/tenants/view/${tenant.clientId}`);
  };

  const handlePermissions = () => {
    handleClose();
    navigate(`/tenants/permissions/${tenant.clientId}`);
  };

  const handlePostProvision = () => {
    handleClose();
    navigate(
      `/tenants/configure/${tenant.clientId}?name=${tenant.clientName}`
    );
  };

   const handleComparision = async () => {
      // if (!sourceVault || !targetVault || !sourceVaultId || !targetVaultId) {
      //   setStatusMessage('Please select both source and target vaults.');
      //   return;
      // }
  
      setMigrating(true);
      // setStatusMessage('');
  
      try {
        // console.log(`Migrating from ${sourceVault} (ID: ${sourceVaultId}) to ${targetVault} (ID: ${targetVaultId})`);
  
        const response = await axios.post(
          config.REACT_APP_ENV_API_BASE + `/dbMigration/dbMigrationCompareExecute`,
          {
            action: "compare",
            Id: tenant.cloneId
          },
          {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${sessionStorage.getItem('login')}`,
            },
          }
        );
  
        console.log('Migration response:', response);
        // await compareVaults();
        // if (response.status >= 200 && response.status < 300) {
        //   setStatusMessage(`Successfully migrated from ${sourceVault} to ${targetVault}`);
        //   // After successful migration, compare the vaults to show any remaining differences
        //   console.log("line300",response?.data?.data);
        //   let newResponse = response?.data?.data;
        //   let newComparisonResult: ComparisonResult = {
        //     sourceVault: sourceVault,
        //     targetVault: targetVault,
        //     missingSecrets: newResponse?.MissingKeys.map((item: { name: any; }) => item.name) || [],
        //     differentSecrets: newResponse?.DifferentKeys.map((item: { name: any; }) => item.name) || []
        //   };
  
        //   //setComparisonResult(newComparisonResult);
        //   console.log("line306", newComparisonResult);
        //   await compareVaults();
        // } else {
        //   throw new Error(response.data?.message || 'Migration failed');
        // }
      } catch (error: any) {
        console.error('Migration failed:', error);
        // setStatusMessage(error.response?.data?.message || 'Failed to migrate vault. Please try again.');
      } finally {
        setMigrating(false);
      }
    };

    return (
      <Box sx={{display: 'flex', justifyContent: 'space-between', gap: 1, alignItems: 'center'}}>
            {/* <Button
              variant="contained"
              size="small"
              startIcon={
                migrating ? <CircularProgress size={20} color="inherit" /> : <CompareArrowsIcon />
              }
              onClick={handleComparision}
              // disabled={!sourceVault || !targetVault || migrating || loading}
              sx={{
                // minWidth: 200,
                backgroundColor: '#734bd1',
                color: 'white',
                '&:hover': {
                  backgroundColor: '#5e3fb0',
                },
                '&.Mui-disabled': {
                  backgroundColor: '#d3c5f1',
                  color: '#fff',
                },
              }}
            >
              {migrating ? 'Comparing...' : 'Compare Permissions'}
            </Button> */}
            <Button
              variant="contained"
              size="small"
              // startIcon={
              //   migrating ? <CircularProgress size={20} color="inherit" /> : <CompareArrowsIcon />
              // }
              onClick={() => navigate(`/DatabaseConfigurations/comparisons/${tenant.cloneId}`)}
              sx={{
                // minWidth: 200,
                backgroundColor: '#734bd1',
                color: 'white',
                '&:hover': {
                  backgroundColor: '#5e3fb0',
                },
                '&.Mui-disabled': {
                  backgroundColor: '#d3c5f1',
                  color: '#fff',
                },
              }}
            >
              View Comparisons
            </Button>
          </Box>
    );

  // return (
  //   <Box display={"flex"}><Button variant="contained" size="small" color="success" onClick={handleComparision}>Compare Permissions</Button><Button>View Comparisons</Button></Box>
  // )

  // return (
  //   <Box>
  //     <IconButton onClick={handleOpen}>
  //       <MoreVertIcon />
  //     </IconButton>
  //     <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
  //       <MenuItem onClick={handleView}>View</MenuItem>
  //       <MenuItem onClick={handlePermissions}>Permissions</MenuItem>
  //       <MenuItem onClick={handlePostProvision}>Post Provision</MenuItem>
  //     </Menu>
  //   </Box>
  // );
};

export default DatabaseConfigurationActionMenu;
